import React, { useState, useEffect } from 'react';
import styles from './Detail.module.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../../layouts/User';
import { Button, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { BASE_URL } from '../../config';
import InfiniteScroll from 'react-infinite-scroll-component';
import ShopListWithProducts from '../../components/ShopListWithProducts';

const breadcrumbs = [
  {
    text: 'หน้าแรก',
    path: '/',
  },
  {
    text: 'หมวดหมู่สินค้า',
    path: '/product-categories',
  },
  {
    text: 'ร้านค้า',
  },
];

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const CategoryDetails: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [hasShops, setHasShops] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [isFetchedData, setIsFetchedData] = useState<boolean>(false);
  const [skip, setSkip] = useState<number>(1);
  const [animationTimeout, setAnimationTimeout] = useState<number>(0);
  const [categoryName, setCategoryName] = useState<string>('');
  const [shops, setShops] = useState<any>([]);
  const [currentPageLocation, setCurrentPageLocation] = useState<any>({
    lat: 0,
    long: 0,
  });
  const user = useSelector((state: any) => state.user);

  const currentLocationLatLong = useSelector(
    (state: any) => state.currentLocation
  );

  const categoryId = searchParams.get('id')?.toString() || '';
  const limit = 10;

  const getApi = async () => {
    if (loading) return;
    const url = `${BASE_URL}/shops/products-category/${categoryId}?lat=${
      currentPageLocation.lat
    }&long=${currentPageLocation.long}&skip=${skip}&limit=${limit}&user=${
      user._id ? user._id : ''
    }`;
    const response = await axios.get(url);

    if (response.data.shops.length < limit) {
      setHasShops(false);
    }

    setTimeout(() => {
      setIsFetchedData(true);
      setAnimationTimeout(500);
      setShops([...shops, ...response.data.shops]);
      setSkip(skip + 1);
      setLoading(false);
    }, animationTimeout);
  };

  const getCategory = async () => {
    if (isFetchedData) return;
    const url = `${BASE_URL}/categorys/${categoryId}`;

    await axios
      .get(url)
      .then(async (res) => {
        setCategoryName(res.data.model.name);
        await getApi();
      })
      .catch((err) => console.log('err :>> ', err));
  };

  const gotoCategoryPage = async () => {
    navigate('/product-categories');
  };

  useEffect(() => {
    if (currentPageLocation.lat) {
      getCategory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPageLocation.lat]);

  useEffect(() => {
    if (currentLocationLatLong.lat && !isFetchedData) {
      setCurrentPageLocation(currentLocationLatLong);
    }
  }, [currentLocationLatLong, isFetchedData]);

  return (
    <>
      <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
        <div className={styles.wrapper}>
          <h1 className={styles.header}>
            หมวดหมู่สินค้า: {categoryName ? categoryName : null}
          </h1>

          {!isFetchedData ? (
            <div style={{ marginTop: '120px', textAlign: 'center' }}>
              <Spin indicator={antIcon} />
              &nbsp;&nbsp;กำลังโหลดรายการร้านค้า
            </div>
          ) : (
            <>
              {shops.length > 0 ? (
                <InfiniteScroll
                  dataLength={shops.length}
                  next={getApi}
                  hasMore={hasShops}
                  loader={
                    <div
                      style={{
                        marginTop: '20px',
                        textAlign: 'center',
                      }}
                    >
                      <Spin indicator={antIcon} />
                      &nbsp;&nbsp;กำลังโหลดรายการร้านค้า
                    </div>
                  }
                  style={{ overflow: 'unset' }}
                >
                  <ShopListWithProducts items={shops} from='categories' />
                </InfiniteScroll>
              ) : (
                <div style={{ textAlign: 'center' }}>
                  <div className={styles.loadingWrapper}></div>
                  ไม่มีรายการสินค้า
                  <div>
                    <Button type='primary' onClick={gotoCategoryPage}>
                      เลือกดูหมวดหมู่อื่นๆ
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </Layout>
    </>
  );
};
export default CategoryDetails;
